import { EntityReferences } from "../models/mappers";
import { EntityName } from "./entityNames";
import { AnyEntityField } from "./metadata";

export const ecommerceFileFields = [
  "gaming_ecommercefileid", // UID
  "createdon", // Date
  "statecode", // Choice
  "statuscode", // Choice
  "gaming_name", // Text
  "gaming_file", // File
  "gaming_file_name", // File Name
  "gaming_ecommerceid", // Lookup - Location
  "gaming_HubLastUpdateByContactId", // Lookup - Contact
] as const;

export const ecommerceFileReferences: EntityReferences<EntityName.gaming_ecommercefile> = {
  [EntityName.gaming_ecommerce]: ["gaming_ecommerceid"],
  [EntityName.contact]: ["gaming_HubLastUpdateByContactId"],
};

export const ecommerceFileKey: AnyEntityField<EntityName.gaming_ecommercefile> =
  "gaming_ecommercefileid";
